import { dashboardApi } from '@/api';

interface DeleteCampaignArgs {
    projectId: string;
    campaignId: string;
}

export const deleteCampaign = async ({
    projectId,
    campaignId,
}: DeleteCampaignArgs) => {
    await dashboardApi({
        method: 'DELETE',
        url: `/customer-campaign/project/${projectId}/campaign/${campaignId}`,
    });
};
